import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfigManager from '../../../common/configManager/configManager';
import MatchViewGazzanet from '../../../components/MatchViewGazzanet';
import IconFont from '../../../components/shared/IconFont';
import Label from '../../../components/shared/Label';
import * as types from '../../../constants';
import { MatchWidgetWrapper, TitleWrapper } from './styles';

class MatchWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: true,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    this.eventTimer = setInterval(this.getEvent, interval);
    this.getEvent();
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.eventTimer) {
      clearInterval(this.eventTimer);
    }
  }

  getEvent = () => {
    const {
      competitionId, sportId, matchId, actions, widgetId,
    } = this.props;
    actions.getLeafEvent(sportId, competitionId, matchId, widgetId);
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 767,
    });
  };

  render() {
    const {
      dictionary, actions,
      sportId, competitionId, matchId, leafEvents, widgetId,
    } = this.props;
    const leafEvent = leafEvents.get(widgetId);
    const { isMobile } = this.state;
    return (
      <MatchWidgetWrapper
        isMobile={isMobile}
      >
        <TitleWrapper>
          <IconFont
            className="icon-matchcenter-circle"
            font={10}
            marginRight={0.4}
            marginleft={0.2}
            color="red"
            pulseEffect
          />
          <Label
            label="Risultati Live"
            weight="bold"
            margin="6px 0"
            isCapitalize
            isTitleNarrowMedium
            size={0.9}
          />
        </TitleWrapper>
        {leafEvent &&
          <MatchViewGazzanet
            currentMatch={leafEvent}
            dictionary={dictionary}
            isMobile={isMobile}
            actions={actions}
            sportId={sportId}
            competitionId={competitionId}
            matchId={matchId}
          />
        }
      </MatchWidgetWrapper>
    );
  }
}

MatchWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  matchId: PropTypes.any,
  dictionary: PropTypes.any,
  leafEvents: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    leafEvents: state.sportsReducer.get('leafEvents'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getLeafEvent: (sportId, competitionId, matchId, widgetId) =>
        dispatch({
          type: types.GET_LEAF_EVENT_REQUEST,
          sportId,
          competitionId,
          matchId,
          widgetId,
        }),
    },
  }),
)(MatchWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/MatchWidgetGazzanet/index.js